var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseFilterMenu", {
    ref: "menu",
    attrs: {
      filters: _vm.menuFilters,
      "menu-width": _vm.menuWidth,
      "active-count-override": _vm.walletActiveCount,
      "menu-title": "Filtros da carteira"
    },
    on: { open: _vm.onMenuOpen, apply: _vm.onApply, clear: _vm.onClear },
    scopedSlots: _vm._u([
      {
        key: "field-wallet",
        fn: function() {
          return [
            _c("ConsolidatorWalletFilter", {
              ref: "filter",
              attrs: {
                stacked: "",
                "defer-apply": "",
                fields: _vm.resolvedFields,
                "enabled-field-keys": _vm.enabledFieldKeys,
                disabled: _vm.disabled
              },
              on: {
                filter: _vm.onFilter,
                "draft-change": _vm.onWalletDraftChange
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }